<template>
    <div class="pt-4">
        <div class="text-center text-im-gray-767676 text-14">
            Serial Code : {{purchase.iimmpactSerial}}
        </div>
        <div class="flex justify-center text-14 pt-2">
            <div class="text-im-gray-767676">Expired Date : </div>
            <div class="pl-1 text-im-red-ff5757">{{getExpierDate()}}</div>
        </div>
    </div>
</template>

<script>
import DatetimeHelper from '@/helper/DatetimeHelper';
export default {
    name: "VoucherLink",
    props: {
        purchase: Object,
    },
    data: function() {
        return {
        }
    },
    created: function() {
    },
    methods: {
        getExpierDate: function () {
            var datePart = this.purchase.iimmpactExpiry;
            var year = datePart;
            var month = datePart;
            var day = datePart;
            year = year.substring(0, 4);
            month = month.substring(4, 6);
            day = day.substring(6, 8);

            var iimmpactExpiryDate = DatetimeHelper.getDateByValue(year , month , day)

            return DatetimeHelper.dateIimmpactIsoFormat(iimmpactExpiryDate)
        },
    }
}
</script>

<style>

</style>
